import React from "react";
import ErrorBoundaryFallback from "./ErrorBoundaryFallback";
import { logger } from "../hooks/Logger";

/**
 * Enviar logs de error al backend cuando esté implementado.
 * Sustituir esta función por la llamada real al API de logs.
 */
export async function reportErrorToBackend(payload) {
	// TODO: cuando estén implementados los logs, llamar al endpoint correspondiente.
	// Ejemplo: await api.post('/logs/error', payload);
	if (process.env.NODE_ENV === "development") {
		console.error("[ErrorBoundary] Payload para reporte (logs no implementados):", payload);
	}
	else {
		logger.error("ErrorBoundary: Error reportado", { payload });
	}
	return Promise.resolve();
}

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
			error: null,
			componentStack: null,
		};
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, info) {
		const componentStack = info?.componentStack ?? null;
		this.setState((prev) => ({
			...prev,
			componentStack,
		}));
		// Log inmediato al capturar (no solo cuando el usuario pulsa "Reportar")
		logger.error("ErrorBoundary: error capturado", {
			message: error?.message,
			stack: error?.stack,
			componentStack,
			url: typeof window !== "undefined" ? window.location?.href : null,
		});
	}

	render() {
		if (this.state.hasError && this.state.error) {
			return (
				<ErrorBoundaryFallback
					error={this.state.error}
					componentStack={this.state.componentStack}
					onReportError={this.props.onReportError ?? reportErrorToBackend}
				/>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
